import { Dropdown, MenuProps } from "antd";
import "./style.scss";
import { DotsMenu } from "../../../Icons/DotsMenu";
import MapPicker from "../../../components/MapComponent";
import { useState } from "react";
import { DeleteConfirmation } from "../AddProviders/DeleteModal";
import { useTranslation } from "react-i18next";

type Props = {
  onCardClick: (data: any) => void;
  onChangePrimary: (data: any) => void;
  deleteItem: (id: number) => void;
  isEdit?: boolean;
  data: {
    id: number;
    name: { en: string };
    isPrimary?: boolean;
    location?: {
      address: string;
      latitude: number;
      longitude: number;
      country: {
        name: {
          ar: string;
          en: string;
        };
      };
      area: {
        name: {
          ar: string;
          en: string;
        };
      };
      city: {
        name: {
          ar: string;
          en: string;
        };
      };
    };
  };
};

export const BranchCards = ({
  data,
  isEdit,
  onCardClick,
  deleteItem,
  onChangePrimary,
}: Props) => {
  const { i18n } = useTranslation();

  const { name, location, isPrimary, id } = data || {};
  const [isDeleteView, setIsDeleteView] = useState<boolean>();

  const items: MenuProps["items"] = [
    {
      label: (
        <p className="menu-item edit" onClick={() => onCardClick(data)}>
          Edit
        </p>
      ),
      key: "3",
    },
    {
      type: "divider",
    },
    {
      label: (
        <p
          className="menu-item set-primary"
          onClick={() => onChangePrimary(data)}
        >
          Set as primary
        </p>
      ),
      key: "2",
    },
    {
      label: (
        <p className="menu-item Delete" onClick={() => setIsDeleteView(true)}>
          Delete
        </p>
      ),
      key: "0",
    },
  ];

  return (
    <>
      <div className={`branch-card-wrapper ${isEdit ? "active-card" : ""}`}>
        <div className="branch-img-location">
          {/* <BranchIcon /> */}
          <MapPicker
            onChange={() => {}}
            height="56px"
            defaultLocation={{
              lat: location?.latitude,
              lng: location?.longitude,
            }}
            disableDefaultUI={true}
            disableZoom={true}
            disableDragging={true}
          />
          {isPrimary && <span> primary </span>}
        </div>
        <div className="branch-derails">
          <p>{name?.[i18n.language || "en"]}</p>
          <span>{location?.address}</span>
          <span>
            {location?.area?.name?.[i18n.language || "en"]},{" "}
            {location?.city?.name?.[i18n.language || "en"]}
          </span>
        </div>

        <div className="branch-menu-action">
          <Dropdown menu={{ items }} trigger={["click"]}>
            <span style={{ cursor: "pointer" }}>
              <DotsMenu />
            </span>
          </Dropdown>
        </div>
      </div>
      {isDeleteView && (
        <DeleteConfirmation
          onCloseModal={() => setIsDeleteView(false)}
          provider={{ ...data, logoUrl: "" }}
          onDelete={() => deleteItem(id)}
          title="Branch"
        />
      )}
    </>
  );
};
